export default "__VITE_ASSET__CjbAPZ4u__"